/**
 * Bei einem Client-Fehler oder Service-Fehler während einer Anfrage, wird die Antwort mittels einer Instanz dieser Klasse zurückgewiesen.
 */
export class HttpError extends Error {
  /**
   * @param response Zurückgewiesene Antwort
   */
  constructor(response) {
    super(response.statusText);
    this.response = response;
  }
  /**
   * Gibt an, ob die Anfrage von jemanden geblockt wurde.
   * @see https://confluence.webapp.sdst.sbaintern.de/display/WEBSSO/Timeouts+und+Fehlercodes
   */
  get isBlockedBy() {
    const statusUnauthorized = 401;
    const statusForbidden = 403;
    const headers = new Headers(this.response.headers);
    const isBlocked = headers.get('X-API-BLOCKED') === '1';
    if (isBlocked && this.response.status !== 206) {
      return 'OAG';
    }
    if (isBlocked && this.response.status === 206) {
      return 'CORB';
    }
    return this.response.status === statusUnauthorized || this.response.status === statusForbidden ? 'API' : null;
  }
  /**
   * Gibt den Http-Status der Antwort zurück.
   */
  get status() {
    return this.response.status;
  }
}
//# sourceMappingURL=http-error.js.map
